// This line should be added at the top of each entry file to the app
// since the CDN is different in QA and Prod, we don't know the path at compile time
// so we can't set it in the webpack config, instead, leave `publicPath` blank and
// set this global variable so that lazy loading will call to correct CDN url in non-dev envs
// https://webpack.js.org/guides/public-path/#on-the-fly
// https://webpack.js.org/configuration/output/#outputpublicpath
// @ts-ignore

__webpack_public_path__ = window.__initialState?.config?.publicPath;

import 'regenerator-runtime/runtime';

import React, { ErrorInfo } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Gettext from '@indeed/indeed-gettext';
import { GlobalStyles, IndeedThemeProvider } from '@indeed/ifl-components';
import { aurora } from '@indeed/ifl-themes';

import AdHocShiftsCreatePage from 'client/pages/AdHocShiftsCreatePage';
import ApplicationError from 'client/components/ApplicationError';
import NotFoundPage from 'client/pages/NotFoundPage';
import initDatadogRum from 'utils/datadog';
import { ClientConfigProvider } from 'client/context/ClientConfigContext';
import { ErrorBoundary } from 'react-error-boundary';
import { LocalizationProvider } from 'client/context/LocalizationContext';
import { datadogRum } from '@datadog/browser-rum';

const initialConfig = window.__initialState || {};
const getText = Gettext(window['indeed.i18n.localeData']);
// Allow the passed state to be garbage-collected
// @ts-ignore Purposely ignoring TS2307
delete window.__initialState;

initDatadogRum(initialConfig);

const onError = (error: Error, info: ErrorInfo): void => {
    if (initialConfig.level === 'local' && process.env.JEST_WORKER_ID === undefined) {
        console.log(error, `\nComponent Stack\n${info.componentStack}`);
    } else {
        datadogRum.addError(error, { info });
    }
};

const WorkerShiftsApp = (): React.JSX.Element => {
    return (
        <ErrorBoundary FallbackComponent={ApplicationError} onError={onError}>
            <IndeedThemeProvider theme={aurora}>
                <GlobalStyles
                    sx={{
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        '#app-root': {
                            gridArea: 'body',
                            gridTemplateAreas: 'body',
                            display: 'flex',
                            flexDirection: 'column',
                            padding: 16,
                        },
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        '#app-root, html, body': { blockSize: '100%' },
                        a: { textDecoration: 'none' },
                    }}
                />
                <ClientConfigProvider clientConfig={initialConfig}>
                    <LocalizationProvider gt={getText}>
                        <BrowserRouter>
                            <main>
                                <Switch>
                                    <Route path="/" exact component={AdHocShiftsCreatePage} />
                                    <Route path="*" component={NotFoundPage} />
                                </Switch>
                            </main>
                        </BrowserRouter>
                    </LocalizationProvider>
                </ClientConfigProvider>
            </IndeedThemeProvider>
        </ErrorBoundary>
    );
};

ReactDOM.render(<WorkerShiftsApp />, document.getElementById('app-root'));
